// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"281":"retomar","358":"gestion"}[chunkId] + "." + {"281":"621382fe","358":"0777937b"}[chunkId] + ".chunk.css";
};